import { render, staticRenderFns } from "./communicationDashboardQRCode.vue?vue&type=template&id=3282e09d&scoped=true"
import script from "./communicationDashboardQRCode.vue?vue&type=script&lang=js"
export * from "./communicationDashboardQRCode.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardQRCode.vue?vue&type=style&index=0&id=3282e09d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282e09d",
  null
  
)

export default component.exports